export const environment = {
  production: false,
  apiUrl: 'https://dev.api.complity.sdidev.es/api',
};
